import { render, staticRenderFns } from "./EditSelection.vue?vue&type=template&id=8ebd300a&scoped=true"
import script from "./EditSelection.vue?vue&type=script&lang=js"
export * from "./EditSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ebd300a",
  null
  
)

export default component.exports